import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getExamsRoleByStudent: ['studentId', 'career', 'period'],
  getExamsRoleByStudentClear: null,
  getExamsRoleByStudentRequest: null,
  getExamsRoleByStudentSuccess: null,
  getExamsRoleByStudentFailure: ['error']
});

export { Creators, Types };
